<div class="message-body">
  {{ message }}
</div>
<button mat-icon-button
        aria-label="Close status message button"
        (click)="close()">
  <mat-icon>close</mat-icon>
</button>
